import { PunctualityReport } from '@src/main/modules/reports/shared/domain/report.interface';
import { TFunction } from 'i18next';
import { Button } from 'primereact/button';
import { useCallback } from 'react';

export const usePunctualityColumnBodies = (
  t: TFunction,
  downloadPdf: (report: PunctualityReport) => void,
  handleDeleteReport: (report: PunctualityReport) => void,
) => {
  const pdfColumnBody = useCallback(
    (rowData: PunctualityReport) => (
      <Button
        icon="pi pi-paperclip"
        className="p-button-text"
        tooltip={t('common.download')}
        onClick={() => downloadPdf(rowData)}
        pt={{ icon: { style: { color: 'var(--primary-color)' } } }}
      />
    ),
    [downloadPdf, t],
  );

  const deleteColumnBody = useCallback(
    (rowData: PunctualityReport) => (
      <Button
        icon="pi pi-trash"
        className="p-button-text p-button-danger"
        tooltip={t('common.delete')}
        onClick={() => handleDeleteReport(rowData)}
      />
    ),
    [handleDeleteReport, t],
  );

  return { pdfColumnBody, deleteColumnBody };
};
